/**
 * Override styles for Payments geo troubleshooting modal (#pr-geo-modal).
 * Only targets classes from GeolocationStylingClasses (Payments docs).
 * Injected when the GeoLocation SDK loads, before locateDevice runs.
 */

const MODAL_BG = '#1a1a2e'
const OVERLAY_BG = 'rgba(0,0,0,0.65)'
const MODAL_MAX_WIDTH = '420px'
const MODAL_FONT = "'Segoe UI', system-ui, -apple-system, sans-serif"

export const GEO_PAYMENT_MODAL_STYLES = `
/* Overlay */
#pr-geo-modal .pr-geo-modal-overlay {
  background: ${OVERLAY_BG} !important;
}

/* Modal */
#pr-geo-modal .pr-geo-modal {
  background: ${MODAL_BG} !important;
  color: #e8e8ec;
  border: 1px solid rgba(255,255,255,0.08);
  border-radius: 12px;
  box-shadow: 0 8px 32px rgba(0,0,0,0.4);
  font-family: ${MODAL_FONT};
  padding: 1.5rem;
  max-width: ${MODAL_MAX_WIDTH};
}

/* Title */
#pr-geo-modal .pr-geo-modal-title {
  color: #fff;
  font-size: 1.9rem;
  font-weight: 600;
  line-height: 1.3;
  letter-spacing: -0.02em;
  margin: 0 0 1.25rem;
}

/* Content */
#pr-geo-modal .pr-geo-modal-content {
  color: #c8c8d4;
  font-family: ${MODAL_FONT};
  font-size: 1.3rem;
  line-height: 1.5;
  margin: 0 0 1.25rem;
}

/* Icon */
#pr-geo-modal .pr-geo-modal-icon {
  filter: brightness(0.7) saturate(0.5) opacity(0.9);
  margin-bottom: 0.5rem;
}

/* Primary button */
#pr-geo-modal .pr-geo-modal-primary-btn {
  background: #3d5a80;
  color: #fff;
  border: none;
  border-radius: 8px;
  padding: 0.75rem 1.75rem;
  font-size: 1.2rem;
  font-weight: 600;
}

#pr-geo-modal .pr-geo-modal-primary-btn:hover {
  background: #4a6a94;
}
`

export function injectGeoPaymentModalStyles(): void {
	if (typeof document === 'undefined') return
	const existing = document.getElementById('geo-payment-modal-styles')
	if (existing) return

	const style = document.createElement('style')
	style.id = 'geo-payment-modal-styles'
	style.textContent = GEO_PAYMENT_MODAL_STYLES
	document.head.appendChild(style)
}
